import { Component, OnInit } from "@angular/core"
import { EduComponent } from "../../utils/eduComponent"
import { ResourceService } from "../../services/resource.service"
import { Attribute } from "../../models/attribute.model"
import { Resource } from "../../models/resource/resource"

@Component({
    selector: "app-resource-attributes",
    templateUrl: "./resource-attributes.component.html",
    styleUrls: ["./resource-attributes.component.scss"],
    standalone: false,
})
export class ResourceAttributesComponent extends EduComponent implements OnInit {
    attributions: Attribute[] = []

    constructor(private resourceService: ResourceService) {
        super()
    }

    ngOnInit() {
        this.addSub(
            this.resourceService.resourceResponse.subscribe((resource: Resource) => {
                let newAtt = resource.attributions.map(
                    (attr) =>
                        new Attribute({
                            ...attr,
                            roles: [],
                        })
                )
                this.setAttributions(newAtt)
            })
        )
    }

    setAttributions(newAttributions: Attribute[]) {
        let preparedAttributions = []
        newAttributions.forEach((attribution) => {
            if (attribution.role === "brand") {
                // These are shown elsewhere
                return
            }
            // Because we don't have ids also check logo url. We have different attributions with the same name
            let addedAttribution = preparedAttributions.find(
                (e) => e.name === attribution.name && e.logoColor === attribution.logoColor
            )
            if (addedAttribution) {
                addedAttribution.roles.push(attribution.role)
                return
            }
            attribution.roles.push(attribution.role)
            preparedAttributions.push(attribution)
        })
        this.attributions = preparedAttributions
    }
}
